import React from "react";
import { FiX } from 'react-icons/fi';
import BorderGradient from 'components/shared/BorderGradient/BorderGradient';

interface InvoiceActionModalProps {
  isOpen: boolean;
  onClose: () => void;
  actionType: "paid" | "schedule";
}

export default function InvoiceActionModal({ isOpen, onClose, actionType }: InvoiceActionModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <BorderGradient className='w-full max-w-3xl'>
        <div className="bg-[#1A1A1A] rounded-lg shadow-lg">
          {/* Modal Header */}
          <div className="flex items-center justify-between p-4 border-b border-white/[0.08]">
            <h2 className="text-xl font-semibold text-white">
              {actionType === "paid" ? "Select Payment Method" : "Schedule Invoice"}
            </h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-[#2A2A2A] rounded-full text-gray-400 hover:text-white"
            >
              <FiX className="w-5 h-5" />
            </button>
          </div>

          <div className="p-6">
            {/* Checkbox (Only for Schedule Invoice) */}
            {actionType === "schedule" && (
              <div className="flex items-center mb-6">
                <input 
                  type="checkbox" 
                  id="scheduleInvoice" 
                  className="w-4 h-4 rounded border-gray-600 bg-[#2A2A2A] text-blue-600 focus:ring-blue-600 focus:ring-offset-gray-800"
                />
                <label htmlFor="scheduleInvoice" className="ml-2 text-gray-400">
                  Schedule Invoice
                </label>
              </div>
            )}

            {/* Dropdown Field */}
            <div className="mb-6">
              <label className="block text-sm font-medium text-gray-400 mb-2">
                {actionType === "paid" ? "Payment Method" : "Schedule Frequency"}
              </label>
              <select className="w-full bg-[#2A2A2A] border border-white/[0.08] rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-600">
                {actionType === "paid" ? (
                  <>
                    <option value="" disabled selected className="text-gray-400">Select Payment Method</option>
                    <option value="credit-card">Credit Card</option>
                    <option value="paypal">PayPal</option>
                    <option value="bank-transfer">Bank Transfer</option>
                  </>
                ) : (
                  <>
                    <option value="" disabled selected className="text-gray-400">Select Frequency</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                    <option value="yearly">Yearly</option>
                  </>
                )}
              </select>
            </div>

            {/* Buttons */}
            <div className="flex gap-3 mt-8">
              <button 
                onClick={onClose}
                className="px-4 w-full bg-[#2A2A2A] py-2 text-sm font-medium text-white rounded-lg hover:bg-opacity-80"
              >
                Save
              </button>
              <button 
                onClick={onClose}
                className="px-4 w-full hover:bg-[#2A2A2A] py-2 text-sm font-medium text-gray-400 rounded-lg hover:text-white"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </BorderGradient>
    </div>
  );
}